import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { GET_USER_PROFILE } from '@/modules/user/profile/queries'
import { useSalaryHistogram } from '@/modules/salary/histogram/use-salary-histogram'
import { SalaryType } from '@/lib/generated/graphql-types'
import {
  formatJobType,
  getTotalCompensation,
} from '@/modules/salary/common/utils'

function getMessageFromSalary(salary: SalaryType) {
  const { jobType, occupation, displayLocation } = salary
  const title = [formatJobType(jobType), occupation?.baseTitlePlusSpecialty]
    .filter(Boolean)
    .join(' ')

  return `Check out this ${title} of ${getTotalCompensation(salary, { isCompact: true })} in ${displayLocation}`
}

const NO_HISTOGRAM_MESSAGE = 'no histogram'

export function useShareMessage({
  salary,
  isAuthenticated,
}: {
  salary?: SalaryType
  isAuthenticated: boolean
}) {
  const { data } = useSalaryHistogram()
  const { data: userProfileData } = useQuery(GET_USER_PROFILE, {
    skip: !isAuthenticated,
  })

  const defaultMessage = useMemo(() => {
    const histogramTitle = data?.getHistogram?.histogramTitle
    const professionTitle =
      histogramTitle?.toLowerCase() === NO_HISTOGRAM_MESSAGE
        ? ''
        : histogramTitle

    const baseMessage = salary
      ? getMessageFromSalary(salary)
      : `Check out these ${professionTitle ? `${professionTitle} ` : ''}salaries on Marit`

    const sender = userProfileData?.getUserProfile?.firstName
      ? `- ${userProfileData.getUserProfile.firstName}`
      : ''

    return [baseMessage, sender].filter(Boolean).join('\n\n')
  }, [data, salary, userProfileData])

  return {
    defaultMessage,
  }
}
